module.exports = __webpack_public_path__ + "media/images/agenda-weo-dd9ec481cfc02d1bae4c1c79d5e1bf69.jpg";